import { motion } from "framer-motion";
import { Phone, Globe } from "lucide-react";
import { GARAGE_PHONE, GARAGE_PHONE_LABEL } from "@/lib/contact";

const GarageDetails = () => (
  <div className="w-full rounded-2xl border border-line bg-gradient-to-br from-panel to-[#0d1117] p-6 sm:p-8 text-left hover:-rotate-1 transition-transform" data-testid="garage-partner-card" style={{ boxShadow: "0 20px 60px rgba(0,0,0,0.45)" }}>
    <div className="flex items-start justify-between gap-4">
      <div>
        <p className="font-mono-ui text-[10px] uppercase tracking-[0.3em] text-slate-500">Garage partenaire</p>
        <p className="font-display text-3xl mt-2" data-testid="garage-partner-name">MECA <span className="text-cyan-400">PUNCH</span></p>
        <p className="mt-1 text-sm text-slate-400">Gros travaux mécaniques — le spécialiste que je recommande</p>
      </div>
      <div className="shrink-0 w-12 h-12 rounded-full border border-cyan-400/50 text-cyan-300 flex items-center justify-center font-display text-lg" aria-hidden="true">MP</div>
    </div>
    <div className="mt-6 space-y-2.5 text-sm">
      <a href={`tel:${GARAGE_PHONE}`} data-testid="garage-phone-link" className="flex items-center gap-2.5 text-slate-200 hover:text-cyan-300 transition-colors w-fit">
        <Phone size={15} className="text-cyan-400" />{GARAGE_PHONE_LABEL}
      </a>
      <p className="flex items-center gap-2.5 text-slate-500" data-testid="garage-website-slot"><Globe size={15} className="text-cyan-400/60" />Site web — bientôt</p>
    </div>
  </div>
);

export const GarageCard = () => (
  <section className="relative py-16 sm:py-24" data-testid="garage-partner-section">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.75, ease: [0.16, 1, 0.3, 1] }} className="text-center">
        <p className="font-mono-ui text-[11px] uppercase tracking-[0.3em] text-slate-500 mb-4">Réseau — gros travaux mécaniques</p>
        <h2 className="font-display uppercase text-3xl sm:text-4xl" data-testid="garage-partner-heading">Le copain garagiste</h2>
        <div className="mt-8 grid md:grid-cols-2 items-center gap-8" data-testid="garage-partner-layout">
          <img src="/realisations/garage-partner.webp" alt="Le mécanicien et sa carte Auto Punch, mécanicien à domicile" loading="lazy" className="w-full aspect-square object-contain rounded-2xl border border-line" data-testid="garage-partner-photo" />
          <GarageDetails />
        </div>
        <p className="mt-6 text-sm text-slate-400 max-w-md mx-auto">Pour les gros travaux mécaniques, je te renvoie directement chez lui — dis-lui que c'est Pépé qui t'envoie.</p>
      </motion.div>
    </div>
  </section>
);